import { Tooltip, Box, Text } from '@chakra-ui/react';
import styles from './JobStatusCellRenderer.module.css';
import JobStatuses from '../utils/jobStatuses';

const JobStatusCellRenderer = ({ value, noCircle = false, comments }) => {
    const status = JobStatuses[value] || {
        type: 'disabled',
        displayedName: 'Unknown',
        toolTip: 'Unknown status',
    };

    const tooltipLabel = status.toolTip + (comments ? `\n${comments}` : '');
    const hasTooltip = Boolean(status.toolTip || comments);

    return (
        <Tooltip
            hasArrow
            isDisabled={!hasTooltip}
            maxW="400px"
            width="auto"
            label={hasTooltip ? tooltipLabel : ''}
            aria-label={status.toolTip}>
            <Box
                className={`${styles.tag} ${styles[status.type + 'Tag']}`}
                sx={{
                    display: 'flex',
                    alignItems: noCircle ? 'center' : null,
                    justifyContent: noCircle ? 'center' : null,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                }}>
                {!noCircle && (
                    <div
                        className={`${styles.circle} ${styles[status.type + 'Circle']}`}
                    />
                )}
                <Text isTruncated>{status.displayedName}</Text>
            </Box>
        </Tooltip>
    );
};

export default JobStatusCellRenderer;
